import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-submission-device-registration',
    templateUrl: './submission-device-registration.component.html',
    styleUrls: ['./submission-device-registration.component.scss'],
    standalone: false
})
export class SubmissionDeviceRegistrationComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  get isAustraliaChannel(): boolean {
    return this.dataScope && this.dataScope.toLowerCase() === 'australia-udi';
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      diRecordPublishDate: ['', { validators: [] }],
      isPrimaryDiSameAsRegisteredOrFiledDi: ['', { validators: [] }],
      registeredOrFiledDi: ['', { validators: [] }],
      deviceRegistrantOrFilerName: ['', { validators: [] }],
      medicalDeviceInfoManagerPhone: ['', { validators: [] }],
      changeDescription: ['', { validators: [] }],
      unifiedSocialCreditCode: ['', { validators: [] }],
      deviceRegistrantOrFilerNameInEnglish: ['', { validators: [] }],
      medicalDeviceInfoManagerEmail: ['', { validators: [] }],
      deviceLicenseNumber: ['', { validators: [] }],
      dataSupplierRole: ['', { validators: [] }],
      dataSupplierId: ['', { validators: [] }],
      multipleSponsorsIndicator: ['', { validators: [] }],
      manufacturerId: ['', { validators: [] }],
      manufacturerName: ['', { validators: [] }],
      registrationOrFilingCertificateNumbersForm: this.fb.array([this.addRegFilForm()])
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  addRegFilForm(): FormGroup {

    return this.fb.group({
      regFilNumber: ['', { validators: [] }]
    });
  }

  patchForms() {

    this.deviceForm.patchValue({

      diRecordPublishDate: this.displayItemData('DI Record Publish Date'),
      isPrimaryDiSameAsRegisteredOrFiledDi: this.displayItemData('Is Primary DI same as the Registered or Filed DI?'),
      registeredOrFiledDi: this.displayItemData('Registered or Filed DI'),
      deviceRegistrantOrFilerName: this.displayItemData('Device Registrant or Filer Name'),
      medicalDeviceInfoManagerPhone: this.displayItemData('Medical Device Information Manager Phone Number'),
      changeDescription: this.displayItemData('Change Description'),
      unifiedSocialCreditCode: this.displayItemData('Unified Social Credit Code'),
      deviceRegistrantOrFilerNameInEnglish: this.displayItemData('Device Registrant or Filer Name in English'),
      medicalDeviceInfoManagerEmail: this.displayItemData('Medical Device Information Manager Email'),
      deviceLicenseNumber: this.displayItemData('Device License Number'),
      dataSupplierRole: this.displayItemData('Data Supplier Role'),
      dataSupplierId: this.displayItemData('Data Supplier ID'),
      multipleSponsorsIndicator: this.displayItemData('Is the device associated with multiple sponsors?'),
      manufacturerId: this.displayItemData('Manufacturer ID'),
      manufacturerName: this.displayItemData('Manufacturer Name')
    });

    this.deviceForm.setControl('registrationOrFilingCertificateNumbersForm', this.setRegFilForm());
  }

  setRegFilForm(): FormArray {

    const formArray = new FormArray([]);

    let item: any;

    item = this.displayItemData('Registration Certificate Number or Filing Certificate Number');

    if (item && item.length > 0) {
      item.forEach((c, i) => {
          formArray.push(

                this.fb.group({
                  regFilNumber: c[(this.getMapInnerPathName('Registration Certificate Number or Filing Certificate Number Value'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  get registrationOrFilingCertificateNumbersForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('registrationOrFilingCertificateNumbersForm');
  }
}

